import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Input } from "design-react-kit";
import Repo from "../../Utility/Repo";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import ViewPDF from "../../Components/ViewPDF";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function CheckISEE(props) {
  const apiToken = useContext(TokenContext);
  const [value, setValue] = useState("");
  const [protocollo, setProtocollo] = useState("");
  const [scadenza, setScadenza] = useState("");
  const [file, setFile] = useState();
  const [year, setYear] = useState();
  const [userData, setUserData] = useState();
  const [validation, setValidation] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isee, setIsee] = useState({});


  let query = useQuery();
  let idIsee = query.get("idIsee");

  const stateMap = {
    LOAD: 0,
    VALIDATED: 1,
    REFUSED: 2,
    ERROR: 3,
  };

  const stateLabels = {
    0: "Caricato",
    1: "Validato",
    2: "Rifiutato",
    3: "Errore",
  };


    const [state, setState] = useState(0);
  const isError = state === stateMap.ERROR;
  const isRefused = state === stateMap.REFUSED;

  useEffect(() => {
    setLoading(false);
    if (idIsee) {
      var obj = document.createElement("object");
      obj.type = "application/pdf";
      obj.data = "data:application/pdf;base64,";
      obj.length = 0;
      setFile(obj);

      Repo.getIsee(apiToken, idIsee)
        .then((response) => {
          if (response.status === 200) {
            obj.data = "data:application/pdf;base64," + response.data.file;
            obj.length = response.data.file.length;
            setFile(obj);
            setValue(response.data.value);
            setProtocollo(response.data.protocollo);
            setYear(response.data.year);
            //  setState(response.data.state); // <-- inizializza lo stato ISEE
            console.log(response.data);

            const data = response.data;

            const stato = response.data.state;

            setState(stateMap[stato] ?? 0);

            // 🔥 Conversione della data da 31/12/2024 ➔ 2024-12-31
            const formattedScadenza = data.scadenza
              ? data.scadenza.split("/").reverse().join("-")
              : "";

            setScadenza(formattedScadenza);
            setIsee(response.data);
            setUserData(response.data.user);
          }
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  const updateISEE = async () => {
    const updatedData = {
      id: idIsee,
      value: value,
      protocollo: protocollo,
      scadenza: scadenza,
      state: state,
      year: year,
    };

    try {
      const response = await Repo.postConfirmIsee(apiToken, updatedData);
      if (response.status === 200) {
        const redirectTo =
          process.env.PUBLIC_URL +
          `/lista_utenti/dati_utente?citizen=${userData.id}&tab=isee`;
        window.location.href = redirectTo;
      } else {
        alert("Errore durante l'aggiornamento dell'ISEE");
      }
    } catch (error) {
      console.error(error);
      alert("Errore tecnico durante il salvataggio");
    }
  };

  return (
    <>
      <div>
        <h1>ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Visualizza o modifica i dettagli dell'ISEE</p>
        </div>

        <div className="row mb-2">
          <div className="col-12">
            <div className="top card-wrapper card-space">
              <div className="card card-bg no-after roundedCustom p-2">
                <div className="card-body">
                  <h6 className="mb-1">Dati Cittadino</h6>
                  <div className="row">
                    <div className="col-lg-4">
                      Nome: <strong>{userData && userData.firstName}</strong>
                    </div>
                    <div className="col-lg-4">
                      Cognome: <strong>{userData && userData.lastName}</strong>
                    </div>
                    <div className="col-lg-4">
                      Codice Fiscale:{" "}
                      <strong>{userData && userData.fiscalCode}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <ViewPDF data={file && file.data} length={file && file.length} />

          <div className="col-lg-4 pl-3">
            <div className="top card-space">
              <div className="card card-bg card-big roundedCustom">
                <div className="card-body">
                  <h6 className="mt-3 mb-1">Valore</h6>
                  <div className="row mb-4">
                    <Input
                      id="value"
                      type="number"
                      required
                      value={value}
                      name="Valore ISEE"
                      onChange={(e) => setValue(e.target.value)}
                    />
                  </div>

                  <h6 className="mt-3 mb-1">Protocollo</h6>
                  <div className="row mb-4">
                    <Input
                      id="protocollo"
                      type="text"
                      required
                      value={protocollo}
                      name="Protocollo ISEE"
                      onChange={(e) => setProtocollo(e.target.value)}
                    />
                  </div>
                  <h6 className="mt-3 mb-1">Anno</h6>
                  <div className="row mb-4">
                    <Input
                      id="year"
                      type="text"
                      required
                      value={year}
                      name="Anno"
                      onChange={(e) => setYear(e.target.value)}
                    />
                  </div>

                  <h6 className="mt-3 mb-1">Scadenza</h6>
                  <div className="row mb-4">
                    <Input
                      id="scadenza"
                      type="date"
                      required
                      value={scadenza}
                      name="Scadenza ISEE"
                      onChange={(e) => setScadenza(e.target.value)}
                    />
                  </div>

                  <h6 className="mt-3 mb-1">Stato</h6>
                  <div className="row mb-4">
                    <select
                      className="form-control"
                      value={state}
                      onChange={(e) => setState(parseInt(e.target.value))}
                    >
                      {Object.entries(stateLabels).map(([val, label]) => (
                        <option key={val} value={val}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="clear"></div>
                  {isRefused && (
                    <div className="alert alert-warning">
                      {isee?.detail ?? "ISEE rifiutato"}
                    </div>
                  )}

                  {isError && (
                    <div className="alert alert-danger">
                      {isee?.detail ?? "Errore durante la verifica dell'ISEE"}
                    </div>
                  )}

                  <div className="text-right mt-4">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={updateISEE}
                    >
                      Salva Modifiche
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!loading && <Loader />}
    </>
  );
}

export default CheckISEE;
